<template lang="pug">
md-input-container
  label(for='income') Income
  md-select#income(name='income', :multiple='multiple', v-model='selected', @selected='onSelected')
    md-option(v-for='income in incomes', :value='income.key', :key='income.key') {{ income.value }}
</template>

<script>
  import { metrics } from '../../assets/data/demographics';

  export default {
    props: {
      value: {
        type: [String, Array],
        required: true
      },
      multiple: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        selected: this.value,
        incomes: metrics.income
      };
    },
    methods: {
      onSelected(value) {
        this.$emit('input', value);
      }
    },
    watch: {
      value(newValue) {
        if (newValue) {
          this.selected = newValue;
        }
      }
    }
  };
</script>



// WEBPACK FOOTER //
// src/shared-components/demographic/IncomeSelector.vue